import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const HeaderOne = createSvgIcon(
  <>
    <path d="M0 14H3.10341V8.2168H8.4V14H11.4962V0H8.4V5.77637H3.10341V0H0V7V14Z" />
    <path d="M19.5997 0H16.611C16.5751 0.854492 15.3137 2.31055 13.4287 2.31055V4.66211C15.0485 4.66211 16.1021 4.08789 16.4175 3.62305H16.5536V14H19.5997V0Z" />
  </>,
  "HeaderOne"
);

export default HeaderOne;
